import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import './contactForm.css';
import {IoLogoWhatsapp} from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import {email, whatsappUrl} from "../../../../components/Constant/socialLinks";
import {FaTelegramPlane} from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import axios from "axios";
import {COMPANY_ADDRESS} from "../../../../utils/companyAddress";

const ContactForm = () => {
    const { t } = useTranslation();
    const ts = (k, d) => t(`sections.contactBlock.${k}`, d);

    const [feedbackMessage, setFeedbackMessage] = useState('');
    const [messageClass, setMessageClass] = useState('');

    const clearFeedbackMessage = () => {
        setTimeout(() => {
            setFeedbackMessage('');
            setMessageClass('');
        }, 3000);  // 3000 milliseconds = 3 seconds
    };

    const sendEmail = async (e) => {
        e.preventDefault();
        const form = e.target;

        const formData = new FormData(form);
        formData.delete('company'); // удаляем honeypot

        const data = Object.fromEntries(formData.entries());

        if (form.company && form.company.value) {
            return;
        }

        setFeedbackMessage(ts('loading'));
        setMessageClass('loading');

        try {
            // Формируем объект для отправки
            const dataForEmail = {
                project: 'offshoreadvisory',
                subject: '/',
                data: data
            };

            const response = await axios.post(
                'https://assembly.tehnik.tech/api/send_form/from',
                dataForEmail,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            );

            form.reset();
            setFeedbackMessage(ts('success'));
            setMessageClass('success');
            clearFeedbackMessage();
        } catch (err) {
            console.error(err);
            setFeedbackMessage(ts('error'));
            setMessageClass('error');
            clearFeedbackMessage();
        }
    };

    return (
        <div className='wrapper'>
            <div className='contact-container container'>
                <div className="contact-form-container">
                    <h2 className='contact-form-title'>{ts('title')}</h2>
                    <form className='contact-form' onSubmit={sendEmail}>
                        <input
                            className='contact-form-input'
                            type="text"
                            id="name"
                            name="name"
                            placeholder={ts('namePlaceholder')}
                            required
                        />
                        <input
                            className='contact-form-input'
                            type="email"
                            id="email"
                            name="email"
                            placeholder={ts('emailPlaceholder')}
                            required
                        />
                        <textarea
                            className='contact-form-input'
                            id="message"
                            name="message"
                            rows={5}
                            placeholder={ts('briefPlaceholder')}
                            required
                        />
                        <button className='contact-button' type="submit">
                            {ts('submit')}
                        </button>
                    </form>
                    {feedbackMessage && <p className={`feedback-message ${messageClass}`}>{feedbackMessage}</p>}
                </div>

                <div className="contact-info">
                    <div className='contact-info-item'>
                        <h2 className='contact-info-title'>
                            <IoLogoWhatsapp/>
                            &nbsp;
                            <FaTelegramPlane/>
                        </h2>
                        <div className='contact-info-content'>
                            
                            <a href={whatsappUrl} className='contact-info-link' target="_blank">
                                +447385054407
                            </a>
                        </div>
                    </div>

                    <div className='contact-info-item'>
                        <h2 className='contact-info-title'>
                            <IoMdMail/>
                        </h2>
                        <div className='contact-info-content'>

                            <a href={email} className='contact-info-link' target="_blank">
                                info@offshoreadvisory.pro
                            </a>
                        </div>
                    </div>
                    
                    <div className='contact-info-item'>
                        <h2 className='contact-info-title'><FaLocationDot/> {ts('addressTitle')}</h2>
                        <div className='contact-info-content'>
                            <p>
                                {COMPANY_ADDRESS}
                            </p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    );
}

export default ContactForm;
